const BLOCKED_USERS_KEY = "nine_blocked_users";

const BlockedUsersService = {
  getBlockedUsers(): Set<string> {
    try {
      const stored = localStorage.getItem(BLOCKED_USERS_KEY);
      if (!stored) return new Set();
      const arr: string[] = JSON.parse(stored);
      return new Set(arr);
    } catch {
      return new Set();
    }
  },

  blockUser(userId: string): void {
    const blocked = this.getBlockedUsers();
    blocked.add(userId);
    localStorage.setItem(BLOCKED_USERS_KEY, JSON.stringify(Array.from(blocked)));
  },

  unblockUser(userId: string): void {
    const blocked = this.getBlockedUsers();
    blocked.delete(userId);
    localStorage.setItem(BLOCKED_USERS_KEY, JSON.stringify(Array.from(blocked)));
  },

  isUserBlocked(userId: string): boolean {
    return this.getBlockedUsers().has(userId);
  },
};

export default BlockedUsersService;
